import { ContextMenu } from '@ohif/ui';
import PropTypes from 'prop-types';
import React from 'react';
import { commandsManager } from './../App.js';

const toolTypes = [
  'Angle',
  'Bidirectional',
  'Length',
  'FreehandMouse',
  'EllipticalRoi',
  'CircleRoi',
  'RectangleRoi',
];

// Tool selector items — always shown on right-click
// These dispatch mprSetTool (for MPR) AND cornerstoneTools.setToolActive (for normal)
const TOOL_ITEMS = [
  { label: 'Stack',          toolName: 'StackScroll' },
  { label: 'Zoom',           toolName: 'Zoom'        },
  { label: 'Level',          toolName: 'Wwwc'        },
  { label: 'Pan',            toolName: 'Pan'         },
  { label: 'Probe',          toolName: 'DragProbe'   },
  { label: 'Length',         toolName: 'Length'      },
  { label: 'Elliptical (HU)',toolName: 'EllipticalRoi' },
  { label: 'Annotate',       toolName: 'ArrowAnnotate' },
];

const ToolContextMenu = ({
  onSetLabel,
  onSetDescription,
  isTouchEvent,
  eventData,
  onClose,
  onDelete,
  isMPR,
}) => {
  const defaultDropdownItems = [
    {
      label: 'Delete measurement',
      actionType: 'Delete',
      action: ({ nearbyToolData, eventData }) =>
        onDelete(nearbyToolData, eventData),
    },
    {
      label: 'Relabel',
      actionType: 'setLabel',
      action: ({ nearbyToolData, eventData }) => {
        const { tool: measurementData } = nearbyToolData;
        onSetLabel(eventData, measurementData);
      },
    },
    {
      actionType: 'setDescription',
      action: ({ nearbyToolData, eventData }) => {
        const { tool: measurementData } = nearbyToolData;
        onSetDescription(eventData, measurementData);
      },
    },
  ];

  // Build tool selector section
  const toolSelectorItems = TOOL_ITEMS.map(({ label, toolName }) => ({
    label,
    action: () => {
      try {
        commandsManager.runCommand('setToolActive', { toolName });
      } catch(e) {
        // Fallback: dispatch directly
        window.dispatchEvent(new CustomEvent('mprSetTool', {
          detail: { toolName, options: { mouseButtonMask: 1 } }
        }));
      }
    },
    params: {},
  }));

  const getDropdownItems = (eventData, isTouchEvent = false) => {
    let measurementItems = [];

    // Only try to get nearby tool data if we have valid eventData (normal viewer)
    if (eventData && eventData.element && eventData.currentPoints && eventData.currentPoints.canvas) {
      const nearbyToolData = commandsManager.runCommand('getNearbyToolData', {
        element: eventData.element,
        canvasCoordinates: eventData.currentPoints.canvas,
        availableToolTypes: toolTypes,
      });

      if (
        isTouchEvent &&
        nearbyToolData &&
        nearbyToolData.toolType === 'arrowAnnotate'
      ) {
        return toolSelectorItems;
      }

      if (nearbyToolData) {
        defaultDropdownItems.forEach(item => {
          item.params = { eventData, nearbyToolData };
          if (item.actionType === 'setDescription') {
            item.label = `${
              nearbyToolData.tool.description ? 'Edit' : 'Add'
            } Description`;
          }
          measurementItems.push(item);
        });
      }
    }

    // Tool selector always shown, measurement actions appended if near an annotation
    const separator = measurementItems.length > 0
      ? [{ label: '─────────────', action: () => {}, params: {}, disabled: true }]
      : [];

    return [...toolSelectorItems, ...separator, ...measurementItems];
  };

  const onClickHandler = ({ action, params, disabled }) => {
    if (disabled) return;
    action(params);
    if (onClose) {
      onClose();
    }
  };

  const dropdownItems = getDropdownItems(eventData, isTouchEvent);

  return (
    <div className="ToolContextMenu">
      <ContextMenu items={dropdownItems} onClick={onClickHandler} />
    </div>
  );
};

ToolContextMenu.propTypes = {
  isTouchEvent: PropTypes.bool.isRequired,
  eventData: PropTypes.object,
  onClose: PropTypes.func,
  onSetDescription: PropTypes.func,
  onSetLabel: PropTypes.func,
  onDelete: PropTypes.func,
  isMPR: PropTypes.bool,
};

ToolContextMenu.defaultProps = {
  isTouchEvent: false,
  isMPR: false,
};

export default ToolContextMenu;
